import { Quill } from "react-quill-new"

// https://github.com/slab/quill/blob/b1b4850f92240dafea2d96c635d39ab490f69527/packages/quill/src/formats/image.ts
// のコピー (BSD 3-clause)
// (ライブラリ Quill の中にも含まれているが、 extends して改造するとアプデ時に壊れそうなのでコピーして使っている)
// ATTRIBUTES に data-managed-image-id を追加している

const EmbedBlot = Quill.import("blots/embed") as {
  new(...args: unknown[]): {
    domNode: HTMLElement
    format(name: string, value: string): void
  }
  create: (value?: unknown) => HTMLElement
  blotName: string
  tagName: string
}

export const PopopoImageBlotAttributes = {
  alt: "alt",
  height: "height",
  width: "width",
  managedImageId: "data-managed-image-id"
} as const

const ATTRIBUTES: string[] = Object.values(PopopoImageBlotAttributes)

function sanitize(url: string, protocols: string[] = ["http", "https", "data"]): boolean {
  const anchor = document.createElement("a")
  anchor.href = url
  const protocol = anchor.href.slice(0, anchor.href.indexOf(":"))
  return protocols.includes(protocol)
}

class PopopoImageBlot extends EmbedBlot {
  static blotName = "image"
  static tagName = "IMG"

  static create(value?: unknown) {
    const node = super.create(value) as HTMLImageElement
    if (typeof value === "string") {
      node.setAttribute("src", this.sanitize(value))
    }
    return node
  }

  static formats(domNode: HTMLImageElement): Record<string, string | null> {
    return ATTRIBUTES.reduce(
      (formats: Record<string, string | null>, attribute) => {
        if (domNode.hasAttribute(attribute)) {
          formats[attribute] = domNode.getAttribute(attribute)
        }
        return formats
      },
      {}
    )
  }

  static match(url: string): boolean {
    return /\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url)
  }

  static register(): void {
    if (/Firefox/i.test(navigator.userAgent)) {
      setTimeout(() => {
        // Disable image resizing in Firefox
        // @ts-expect-error
        document.execCommand("enableObjectResizing", false, false)
      }, 1)
    }
  }

  static sanitize(url: string): string {
    return sanitize(url, ["http", "https", "data"]) ? url : "//:0"
  }

  static value(domNode: HTMLImageElement): string | null {
    return domNode.getAttribute("src")
  }

  domNode!: HTMLImageElement

  format(name: string, value: string): void {
    if (-1 < ATTRIBUTES.indexOf(name)) {
      if (value) {
        this.domNode.setAttribute(name, value)
      } else {
        this.domNode.removeAttribute(name)
      }
    } else {
      super.format(name, value)
    }
  }
}

export function registerPopopoImageBlot(): void {
  Quill.register("formats/image", PopopoImageBlot, true)
}
